import { Component, OnDestroy, OnInit } from '../../../../../core/decorators';

@Component({
    selector: 'filter-bool',
    bindings: {
        filter: '=',
        model: '='
    },
    template: require('./filter-bool.tpl.html')
})
export class FilterBoolComponent implements OnInit, OnDestroy {
    constructor() {}

    ngOnInit(): void {}

    ngOnDestroy(): void {}
}
